import { ReactNode } from 'react';
import { Card, DetailRow, DetailRows, withStyles } from 'vopay';
import { Title } from 'UI';
import styles from './TransactionDetailsCard.module.scss';

type TransactionDetailsCardProps = {
  title: ReactNode;
  details: DetailRow[];
};

const cn = withStyles(styles);

export default function TransactionDetailsCard({ title, details }: TransactionDetailsCardProps) {
  return (
    <Card className={cn('card')}>
      <Title level="4" className={cn('title')}>
        {title}
      </Title>

      <DetailRows details={details} />
    </Card>
  );
}
